import React from 'react'
import { cn } from '~/utils/cn'

export type FormControlProps = PropsWithClassName<{
  fullWidth?: boolean
  disabled?: boolean
}> &
  PropsWithChildrenRequired

const FormControl = ({
  children,
  className,
  disabled = false,
  fullWidth = false
}: FormControlProps) => {
  return (
    <div
      aria-disabled={disabled}
      className={cn(className, 'flex flex-col gap-y-1', {
        'w-full': fullWidth
      })}
    >
      {children}
    </div>
  )
}

export default FormControl
